import { render, staticRenderFns } from "./OpportunityDashboard.vue?vue&type=template&id=ce37e2c2&"
import script from "./OpportunityDashboard.vue?vue&type=script&lang=js&"
export * from "./OpportunityDashboard.vue?vue&type=script&lang=js&"
import style0 from "./OpportunityDashboard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports